// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { UserModel } from '../model/user.model';
import { ProjectModel } from '@project/model/project.model';
import { UserProfileVO } from '../model/vo/user.vo';
import { UserOptionDefsVO } from '../model/vo/user-option-defs.vo';
import { ProjectOptionDefService } from '@project/components/import-export/service/project-option-def.service';
import { ArticleNumberMappingListVO } from '@article/model/vo/article-number-mapping.vo';
import { CollectionService } from '../components/favorites/service/collection.service';
import { ArticleNumberMappingService } from '@article/service/article-number-mapping.service';
import { UnusedLabelingService } from '@project/components/label/label-editor/service/unused-labeling.service';
import { UserModelService } from '../model/user.model.service';
import { lastValueFrom } from 'rxjs';
import { ProjectUserModel } from '@project/model/project-user.model';

@Injectable({ providedIn: 'root' })
export class UserProfileService {

  constructor(
    private userModel: UserModel,
    private projectModel: ProjectModel,
    private projectOptionDefService: ProjectOptionDefService,
    private articleNumberMappingService: ArticleNumberMappingService,
    private collectionService: CollectionService,
    private unusedLabelingService: UnusedLabelingService,
    private userModelService: UserModelService,
    private projectUserModel: ProjectUserModel) {
  }

  public setUserProfile(userProfileVO: UserProfileVO) {
    this.userModel.userProfile = userProfileVO;
    this.userModel.articleNumberMappingLists = null;
    this.projectUserModel.projectOptionDefs = null;
    if (this.userModel.userProfile) {
      if (this.userModel.userProfile.user.hasPermission("LOAD_PROJECT_OPTION_DEFINITIONS")) {
        lastValueFrom(this.projectOptionDefService
          .loadOptionDefsByUserId(this.userModel.userProfile.isRegisteredUserAccount() ? this.userModel.user.id : NaN))
          .then((result: UserOptionDefsVO) => {
            this.projectUserModel.projectOptionDefs = result.projectOptionDefs;
            this.projectUserModel.projectGroupOptionDefs = result.projectGroupOptionDefs;
            this.projectModel.applyUserOptions(result);
          });
      }
      if (
        this.userModel.userProfile.user.hasPermission("GET_LIST_OF_ARTICLE_NUMBER_MAPPINGS") &&
        this.userModel.userProfile.isRegisteredUserAccount()
      ) {
        this.articleNumberMappingService.loadMappingListsByUserId(this.userModel.user.id).subscribe((data: ArticleNumberMappingListVO[]) => {
          this.userModel.articleNumberMappingLists = data;
        });
      }
    }
    this.notifyUserProfileChange();
    this.collectionService.notifyCollectionUpdated();
  }

  private notifyUserProfileChange(): void {
    this.unusedLabelingService.favoriteArticlesUpdatedHandler();
    this.userModelService.notifyUserProfileChanged();
  }
}
